import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import "./user-info-display.styles.scss";

//RK Task#105 UserInfoDisplay Details
//RK Updated Edit to Edit Profile
function UserInfoDisplay() {
    const normaluser = useSelector(({ user }) => user.loggedin_user);
    const improfileuser = useSelector(({ cart }) => cart.impersonateMember ? cart.impersonateMember.userprofile : null);

    const [userInfo, setUserInfo] = useState(improfileuser !== null && improfileuser ? improfileuser : normaluser);

    if (userInfo) {
        return (
            <div className="user-info-display">
                <h3 className="name">{userInfo != null && (userInfo.FirstName !== undefined ? userInfo.FirstName : '') + " " + (userInfo.LastName !== undefined ? userInfo.LastName : '')}</h3>
                <p className="text-container">
                    <div className="left">
                        <span
                            className="position-title">{userInfo != undefined && userInfo.Company != null ? userInfo.Company : ""}</span>
                        <span className="address">
                            {(userInfo != null && userInfo.Address !== undefined ? userInfo.Address : "") + (userInfo != null && userInfo.AddressTwo != null ? ", " + userInfo.AddressTwo : "")}
                        </span>
                        <span className="city-zip">
                            {(userInfo != null && userInfo.City != null ? userInfo.City + "" : "") +
                                (userInfo != null && userInfo.StateName !== undefined ?  ", " + userInfo.StateName : "") +
                                (userInfo != null && userInfo.PostalCode != null ? " " + userInfo.PostalCode : "")}
                        </span>
                    </div>
                    <span className="spacer d-sm-none" />
                    <div className="right">
                        <span className="phone">{userInfo != null && userInfo.PhoneNumber ? "P: " + userInfo.PhoneNumber : ""}</span>
                        <span className="edit-profile">
                            <Link to="/edit-profile">
                                <i className="fa fa-pencil" aria-hidden="true" style={{marginRight: 1}} />
                                Edit Profile
                            </Link>
                        </span>

                        <span className="edit-profile">
                            <Link to={{
                                pathname: "/changePassword",
                                state: {
                                    userInfo: userInfo
                                }
                            }}>
                                <i className="fa fa-lock" aria-hidden="true" style={{marginRight: 1}} />
                                Change Password
                            </Link>
                        </span>
                    </div>
                </p>
            </div>
        );
    }
    else
        return null;
}

export default UserInfoDisplay;
